<template>
    <div class="mandate">
    </div>
</template>

<script>
import lenderOnboardingService from '@/services/lenderOnboardingService.js'
import store from '@/store/index.js'
import router from '@/router/index.js'

const registerWidget = async (widgetToken) => {
    const payload = {
        widgetToken: widgetToken
    }
    await lenderOnboardingService.getWidgetToken(payload)
    store.commit('isNotLoading')
}

const eSignSuccess = async (docketId) => {
    store.commit('isLoading')
    await lenderOnboardingService.signConfirmationRequest({ docketId: docketId }).then(async (res) => {
        if (res.status === 200) {
            store.dispatch('dashboard/setField', { field: 'isLenderContractSigned', value: true })
            store.dispatch('dashboard/setField', { field: 'generatedReferralCode', value: res.data.generatedReferralCode })

            router.push('/dashboard')
        }
    })
    store.commit('isNotLoading')
}

export default {
    name: 'ESign',
    data () {
        return {
            mandateId: '',
            docketId: null,
            signerId: null,
            documentId: null,
            apiId: null
        }
    },
    mounted () {
        window.scrollTo(0, 0)
        const script = document.createElement('script')
        script.async = true
        script.src = process.env.VUE_APP_ESIGN_URL
        document.getElementsByTagName('head')[0].appendChild(script)
        this.signRequest()
    },
    methods: {
        async signRequest () {
            this.$store.commit('isLoading')
            await lenderOnboardingService.signRequest().then((res) => {
                if (res.status === 200) {
                    this.docketId = res.data.docket_id
                    this.signerId = res.data.signer_id
                    this.documentId = res.data.document_id
                    this.apiId = res.data.signDeskAppId

                    setTimeout(() => {
                        this.callWidget(this.docketId, this.signerId, this.documentId, this.apiId)
                    }, 200)
                } else {
                    this.$store.commit('isNotLoading')
                    this.$emit('failure')
                }
                this.$store.commit('isNotLoading')
            })
        },
        callWidget (docketId, signerId, documentId, apiId) {
            const options = {
                docket_id: docketId,
                signer_id: signerId,
                document_id: documentId,
                id: apiId,
                widget_width: '100vw',
                widget_height: '100vh',

                getWidgetToken: async function (result) {
                    await registerWidget(result)
                },
                signatureStatus: async function (result) {
                    if (result.status === 'success') {
                        await eSignSuccess(this.docket_id)
                    }
                },
                errorLog: function (result) {
                    console.log('Error: ', result)
                }
            }
            window.esignWidgetCall(options)
        }

    }
}
</script>

<style lang="scss">
.modalDialogWidget {
    top: 12px !important;
    background-color: unset !important;
}

.esign-widget-loading {
    top: 50% !important;
}

@media (max-width: 1024px) {
    .modalDialogWidget {
        top: 42px !important;
    }
}
</style>
